import { render } from "./IntroScene.vue?vue&type=template&id=4bbbf21e"
import script from "./IntroScene.vue?vue&type=script&lang=js"
export * from "./IntroScene.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__